import {
  ApiRecommendationProduct,
  ApiRecommendationProducts
} from '../../../../services/eaptekaApi';
import {
  RecommendationProducts,
  RecommendationProductWithAnalytics
} from '../../../recommendationProducts/types';
import { ProductEntity, ProductId } from '../../../types';
import { serializeRecommendationProduct } from './serializeRecommendationProduct';

export const serializeRecommendationProductsFromApi = (
  data: ApiRecommendationProducts
): RecommendationProducts => {
  return {
    recommendationProducts:
      data.recommendationProducts.reduce<
        ProductEntity<RecommendationProductWithAnalytics>
      >(
        (
          byId: ProductEntity<RecommendationProductWithAnalytics>,
          product: ApiRecommendationProduct
        ) => {
          byId[product.id as ProductId] =
            serializeRecommendationProduct(product);

          return byId;
        },
        {}
      ),
    productsBond: data.productsBond
  };
};
